import { fehlertext } from '../../api/client'
import { useMe, useSelbstpruefung } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { Stand } from './DiensteCard'

/**
 * Die Selbstprüfung der Installation (#62): was `/api/health` weiß, und dazu,
 * was das Hosting entscheidet -- Schreibrechte, PHP-Grenzen, Erweiterungen.
 * Ein Blick nach dem Upload statt `/api/health` im Browser aufzurufen.
 */
export function SelbstpruefungCard() {
  const t = useTexte().betrieb
  // Dieselbe Angabe wie in den Diensten (Codereview E7).
  const bausteine = useTexte().bausteine
  const me = useMe()
  const check = useSelbstpruefung(me.data?.may_operate === true)

  if (check.isPending) return <p className="card__lead leise">…</p>
  if (check.isError) {
    return (
      <p className="notice" role="alert">
        {fehlertext(check.error)}
      </p>
    )
  }
  const p = check.data

  const zeile = (name: string, an: boolean, text?: string, schluessel?: string) => (
    <p className="dienst" data-pruefung={schluessel ?? name}>
      <span className="dienst__name">{name}</span>
      {text !== undefined && <span className="dienst__zeilen">{text}</span>}
      <Stand an={an} />
    </p>
  )
  const wert = (name: string, text: string, schluessel: string) => (
    <p className="dienst" data-pruefung={schluessel}>
      <span className="dienst__name">{name}</span>
      <span className="dienst__zeilen">{text}</span>
    </p>
  )

  return (
    <div className="card card--seite" data-selbstpruefung="">
      <p className="card__lead">{t.selbstpruefungLead}</p>
      {wert(t.version, p.version, 'version')}
      {wert(t.build, p.build, 'build')}
      {zeile(t.datenbank, p.database, p.database_version ?? undefined, 'datenbank')}
      {zeile(t.schema, p.schema_missing.length === 0, p.schema_missing.length > 0 ? t.schemaFehlt(p.schema_missing) : undefined, 'schema')}
      {wert(t.php, p.php, 'php')}
      {zeile(t.envDatei, p.env_exists, undefined, 'env')}
      {zeile(t.envSchreibbar, p.env_writable, undefined, 'env-schreibbar')}
      {zeile(t.medienOrdner, p.media_writable, p.media_dir, 'medien')}
      {wert(t.postMax, p.post_max_size, 'post-max')}
      {wert(t.uploadMax, p.upload_max_filesize, 'upload-max')}
      {wert(t.speicherGrenze, p.memory_limit, 'memory')}
      {wert(t.laufzeit, p.max_execution_time, 'laufzeit')}
      {zeile(t.zip, p.zip, undefined, 'zip')}
      {zeile(t.sicherungAes, p.backup_encryption, undefined, 'sicherung-aes')}
      {zeile(t.gd, p.gd, undefined, 'gd')}
      {zeile(t.openssl, p.openssl, undefined, 'openssl')}
      {zeile(t.curl, p.curl, undefined, 'curl')}
      {zeile(t.buchSchrift, p.book_font, undefined, 'buch-schrift')}
      {zeile(bausteine.buchEmoji, p.book_emoji, undefined, 'buch-emoji')}
      {zeile(t.appUrl, p.app_url_set, undefined, 'app-url')}
      {zeile(t.mail, p.mail_from_set, t.mailWie(p.mail_transport, p.mail_from_set), 'mail')}
      {zeile(t.push, p.push, undefined, 'push')}
      {zeile(t.appleMaps, p.apple_maps, undefined, 'apple-maps')}
      {zeile(t.appleWeather, p.apple_weather, undefined, 'apple-weather')}
      {zeile(t.appleMusic, p.apple_music, undefined, 'apple-music')}
      {zeile(t.giphy, p.giphy, undefined, 'giphy')}
      {zeile(t.kartenquelleFest, p.map_fixed, undefined, 'karte-fest')}
      {zeile(t.betreiber, p.operator_complete, undefined, 'betreiber')}
    </div>
  )
}
